import axios from 'axios';
import {
  GetUpLoadImgUrl,
} from '../api/weChat';
import {
  GetImageUploadUrl,
} from '../api/customer';
import {
  CusLoadingOpen,
  CusLoadingClose,
} from '@/utils/CustomToast';

// 格式化日期，格式：年-月-日
export function formatDate(date) {
  const de = new Date(date);
  const y = de.getFullYear();
  const m = String(de.getMonth() + 1).padStart(2, '0');
  const d = String(de.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// 格式化日期，格式：年月日
export function formatDateId(date) {
  const de = new Date(date);
  const y = de.getFullYear();
  const m = String(de.getMonth() + 1).padStart(2, '0');
  const d = String(de.getDate()).padStart(2, '0');
  return `${y}${m}${d}`;
}

// 格式化日期，格式：年-月
export function formatDateYm(date) {
  const de = new Date(date);
  const y = de.getFullYear();
  const m = String(de.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

/*
 * 判断obj是否为一个整数
 */
function isInteger(obj) {
  return Math.floor(obj) === obj;
}

/*
 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
 * @param floatNum {number} 小数
 * @return {object}
 *   {times:100, num: 314}
 */
function toInteger(floatNum) {
  var ret = {
    times: 1,
    num: 0,
  };
  if (isInteger(floatNum)) {
    ret.num = floatNum;
    return ret;
  }
  var strfi = floatNum + '';
  var dotPos = strfi.indexOf('.');
  var len = strfi.substr(dotPos + 1).length;
  var times = Math.pow(10, len);
  var intNum = parseInt(floatNum * times + 0.5, 10);
  ret.times = times;
  ret.num = intNum;
  return ret;
}

/*
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 *
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
 *
 */
function operation(a, b, op) {
  var o1 = toInteger(a);
  var o2 = toInteger(b);
  var n1 = o1.num;
  var n2 = o2.num;
  var t1 = o1.times;
  var t2 = o2.times;
  var max = t1 > t2 ? t1 : t2;
  var result = null;
  switch (op) {
    case 'add':
      if (t1 === t2) {
        // 两个小数位数相同
        result = n1 + n2;
      } else if (t1 > t2) {
        // o1 小数位 大于 o2
        result = n1 + n2 * (t1 / t2);
      } else {
        // o1 小数位 小于 o2
        result = n1 * (t2 / t1) + n2;
      }
      return result / max;
    case 'subtract':
      if (t1 === t2) {
        result = n1 - n2;
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2);
      } else {
        result = n1 * (t2 / t1) - n2;
      }
      return result / max;
    case 'multiply':
      result = (n1 * n2) / (t1 * t2);
      return result;
    case 'divide':
      result = (n1 / n2) * (t2 / t1);
      return result;
  }
}

// 加减乘除的四个接口
export function add(a, b) {
  return operation(a, b, 'add');
}

export function subtract(a, b) {
  return operation(a, b, 'subtract');
}

export function multiply(a, b) {
  return operation(a, b, 'multiply');
}

export function divide(a, b) {
  return operation(a, b, 'divide');
}

// 上传图片
export function upLoadImg(
  blob,
  base64,
  type,
  yes = null,
  no = null,
  startIndex = 0
) {
  CusLoadingOpen('上传中...');
  GetUpLoadImgUrl().then((res) => {
    const formData = new FormData();
    formData.append('fileField', blob || b64toBlob(base64), 'picture.jpg');
    if (type === 'renXiang' || type === 'grantRenXiang') {
      formData.append('fileType', 'H5idcardFront');
    }
    if (type === 'guoHui' || type === 'grantGuoHui') {
      formData.append('fileType', 'H5idcardBack');
    }
    if (type === 'renLian' || type === 'ymt') {
      formData.append('fileType', 'weChatPic');
    }
    axios
      .post(res.rows[startIndex], formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        CusLoadingClose();
        yes && yes(res.data);
      })
      .catch((err) => {
        CusLoadingClose();
        const i = startIndex + 1;
        if (i < res.rows.length) upLoadImg(blob, base64, type, yes, no, i);
        else no && no(err);
      });
  });
}

// 代理商的助手App上传图片功能
export function upLoadImgForAgent(blob, base64, type, yes = null, no = null) {
  CusLoadingOpen('上传中...');
  GetImageUploadUrl().then((res) => {
    const formData = new FormData();
    formData.append('fileField', blob || b64toBlob(base64), 'picture.jpg');
    if (type === 'renXiang' || type === 'grantRenXiang') {
      formData.append('fileType', 'H5idcardFront');
    }
    if (type === 'guoHui' || type === 'grantGuoHui') {
      formData.append('fileType', 'H5idcardBack');
    }
    if (type === 'renLian' || type === 'ymt') {
      formData.append('fileType', 'weChatPic');
    }
    axios
      .post(res.data.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        CusLoadingClose();
        yes && yes(res.data);
      })
      .catch((err) => {
        CusLoadingClose();
        no && no(err);
      });
  });
}

// 无登录上传图片功能
export function commitmentUpLoadImg(
  blob,
  base64,
  type,
  url,
  yes = null,
  no = null
) {
  CusLoadingOpen('上传中...');
  const formData = new FormData();
  formData.append('fileField', blob || b64toBlob(base64), 'picture.jpg');
  if (type === 'renXiang' || type === 'grantRenXiang') {
    formData.append('fileType', 'H5idcardFront');
  }
  if (type === 'guoHui' || type === 'grantGuoHui') {
    formData.append('fileType', 'H5idcardBack');
  }
  if (type === 'renLian' || type === 'ymt') {
    formData.append('fileType', 'weChatPic');
  }
  axios
    .post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      CusLoadingClose();
      yes && yes(res.data);
    })
    .catch((err) => {
      CusLoadingClose();
      no && no(err);
    });
}

// base64转Blob
function b64toBlob(b64) {
  const str64 = b64.indexOf(',') > -1 ? b64.split(',')[1] : b64;
  const byteString = window.atob(str64);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {
    type: 'image/jpeg',
  });
}
